module.exports = __webpack_public_path__ + "static/head-section-50530943f009aa0ccc35194c129e9ced.png";